import InputType from './InputType'
import SelectType from './SelectType'
import TypeElement from './TypeElement'
import SignatureType from './SignatureType';
import PhotoBoardType from './PhotoBoardType'

/**
 * @constructor
 */
function TypeFactory() {}

/**
 * @type {Object}
 */
TypeFactory.registry = {
  input: InputType,
  select: SelectType,
  'photo-board': PhotoBoardType
}

/**
 * @param {string} type
 * @param code
 * @return {Class|null}
 */
TypeFactory.create = (type, code) => {

  if (String(code).includes('signature')) {
    return SignatureType;
  }

  return TypeFactory.registry[type] || null
}

/**
 * @type {TypeElement}
 */
TypeFactory.TypeElement = TypeElement

export {
  TypeElement,
  TypeFactory
}
